import dayjs from 'dayjs';

const dateUtil = {
    toDateString(dateStr) {
        if (!dateStr) return '';
        return dayjs(dateStr).format('MMM D, YYYY');
    },
    toISOString(date) {
        return dayjs(date).toISOString();
    },
    timeAgo(isoString) {
        if (!isoString) return '';
        const hours = Math.max(1, Math.round((Date.now() - new Date(isoString).getTime()) / 3600000));
        if (hours < 24) return `${hours}h ago`;
        const days = Math.floor(hours / 24);
        return `${days}d ago`;
    },
};

export default dateUtil;
